import { render, staticRenderFns } from "./EnglishProfileAiCard.vue?vue&type=template&id=5865f6c4&scoped=true"
import script from "./EnglishProfileAiCard.vue?vue&type=script&lang=js"
export * from "./EnglishProfileAiCard.vue?vue&type=script&lang=js"
import style0 from "./EnglishProfileAiCard.vue?vue&type=style&index=0&id=5865f6c4&prod&scoped=true&lang=scss"
import style1 from "./EnglishProfileAiCard.vue?vue&type=style&index=1&id=5865f6c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5865f6c4",
  null
  
)

export default component.exports